import { render, staticRenderFns } from "./SystemInformModal.vue?vue&type=template&id=ac434f32&scoped=true"
import script from "./SystemInformModal.vue?vue&type=script&lang=js"
export * from "./SystemInformModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac434f32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac434f32')) {
      api.createRecord('ac434f32', component.options)
    } else {
      api.reload('ac434f32', component.options)
    }
    module.hot.accept("./SystemInformModal.vue?vue&type=template&id=ac434f32&scoped=true", function () {
      api.rerender('ac434f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/systemInform/modules/SystemInformModal.vue"
export default component.exports